import { render, staticRenderFns } from "./BuddieDetail.vue?vue&type=template&id=2312dd8b&scoped=true"
import script from "./BuddieDetail.vue?vue&type=script&lang=js"
export * from "./BuddieDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddieDetail.vue?vue&type=style&index=0&id=2312dd8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2312dd8b",
  null
  
)

export default component.exports